module.exports = __webpack_public_path__ + "static/media/dubailog.5e3160a2.png";